import { useConstructionAnimation } from "@gettactic/map-builder/src/components/map/animation/ConstructionAnimationContext";
import {
  CONSTRUCTION_DURATION,
  CONSTRUCTION_LIFT,
  constructionTiming
} from "@gettactic/map-builder/src/components/map/animation/constructionTiming";
import React from "react";

export function useSvgConstructionAnimation(
  svgRef: React.RefObject<SVGSVGElement | null>
) {
  const { register } = useConstructionAnimation();
  React.useEffect(
    () =>
      register((map) => {
        const svg = svgRef.current;
        if (!svg) return () => {};
        const shapes = new Map(map.shapes.map((shape) => [shape.id, shape]));
        const nodes = Array.from(
          svg.querySelectorAll<SVGGElement>("[data-shape-id]")
        ).filter((node) => {
          const shape = shapes.get(node.dataset.shapeId!);
          return (
            shape &&
            shape.layerType !== "background" &&
            shape.layerType !== "floor"
          );
        });
        const rank = (node: SVGGElement) => {
          const type = shapes.get(node.dataset.shapeId!)!.type;
          return type === "wall-path" || type === "wall"
            ? 0
            : type === "spot" || type === "text"
              ? 2
              : 1;
        };
        nodes.sort(
          (a, b) =>
            rank(a) - rank(b) ||
            shapes.get(a.dataset.shapeId!)!.y -
              shapes.get(b.dataset.shapeId!)!.y
        );
        const animations: Animation[] = [];
        const timing = constructionTiming(nodes.length);
        nodes.forEach((node, index) => {
          if (!node.animate) return;
          const offset = CONSTRUCTION_LIFT;
          animations.push(
            node.animate(
              [
                { transform: `translateY(${offset}px)`, opacity: 0 },
                { transform: "translateY(0px)", opacity: 1 }
              ],
              {
                duration: CONSTRUCTION_DURATION,
                delay: timing.delay(index),
                easing: "cubic-bezier(0.16, 1, 0.3, 1)",
                fill: "backwards"
              }
            )
          );
        });
        svg
          .querySelectorAll<SVGGElement>(
            '[data-layer="wall-floor-fill"], [data-layer="wall-junctions"]'
          )
          .forEach((node) => {
            if (node.animate)
              animations.push(
                node.animate([{ opacity: 0 }, { opacity: 1 }], {
                  duration: 300,
                  delay: timing.end,
                  fill: "backwards"
                })
              );
          });
        return () => {
          animations.forEach((animation) => {
            animation.cancel();
          });
        };
      }),
    [register, svgRef]
  );
}
